import React, { useEffect, useState } from "react";
import naijaXbyState from "naija-xbystate";
import DatePicker from "react-datepicker";
import { Input } from "../Input";
import { ImageUploader } from "../ImageUploader";
import { Controller } from "react-hook-form";
import { FileUploader } from "../FileUploader";
import { Select } from "../Select";
import { GovernmentIdUpload } from "../GovernmentIdUpload";
import { covertToCamel } from "../../../utils";
import { NumberInput } from "../NumberInput";
import { ErrorMessage } from "@hookform/error-message";

import "react-datepicker/dist/react-datepicker.css";
import "../../../App.css";
import Radio from "../Radio/Radio";
import { ListInputs } from "../ListInputs";

const InputGenerator = ({
  builder,
  handleInputChange,
  tabName,
  bankComponent,
  showButton,
  handleFileChange,
  errors,
  setSelectedState,
  requiredField,
  register,
  control,
  handleLinkForm,
  tabId,
  theme,
  lgas,
  senatorialDistricts,
  linkedTabs,
  getValues,
  setLga,
  setSenatorialDistricts,
}: any) => {
  const states = naijaXbyState.states();
  const [image, setImage] = useState("");
  const [file, setFile] = useState("");

  const selectedState = getValues("state");

  useEffect(() => {
    if (selectedState) {
      const stateLgas = naijaXbyState.lgas(selectedState);
      setLga(stateLgas);

      const districts = naijaXbyState.senatorialDistricts(selectedState);
      setSenatorialDistricts(districts);
    }
  }, [selectedState]);

  function handleImageChange(e: React.ChangeEvent<any>) {
    const { validity, files, name } = e.target;
    const file = files[0];
    const reader = new FileReader();
    if (file) {
      setImage(URL.createObjectURL(file));
      setFile(file);
      reader.readAsDataURL(file);
      reader.onload = () => {
        handleFileChange(tabName, {
          name,
          fileDetails: { file, validity: validity.valid },
        });
      };
    }
  }

  const inputName = covertToCamel(builder?.instruction || "");

  if (builder.title === "Bank Info") {
    showButton(false);
    return bankComponent;
  }

  const handleStateChange = (value: string) => {
    setSelectedState(value);
  };

  if (builder.title === "Select State") {
    showButton(true);
    return (
      <>
        <Select
          required={requiredField.includes(inputName)}
          register={register}
          name={inputName}
          options={states.map((s: string) => ({ option: s, id: s }))}
          instruction={builder.instruction}
          theme={theme}
          setSelectedState={handleStateChange}
          errors={errors}
          getValues={getValues}
        />
      </>
    );
  }
  if (builder.title === "Select LGA") {
    showButton(true);
    return (
      <>
        <Select
          required={requiredField.includes(inputName)}
          register={register}
          name={inputName}
          options={lgas.map((l: string) => ({ option: l, id: l }))}
          instruction={builder.instruction}
          theme={theme}
          errors={errors}
          getValues={getValues}
        />
      </>
    );
  }
  if (builder.title === "Select Senatorial District") {
    showButton(true);

    const stateDistricts = senatorialDistricts?.filter((district: string) => {
      const selectedState = getValues("state");
      return selectedState
        ? district?.toLowerCase().includes(selectedState?.toLowerCase())
        : [];
    });
    return (
      <>
        <Select
          required={requiredField.includes(inputName)}
          name={inputName}
          register={register}
          options={stateDistricts?.map((sd: string) => ({
            option: sd,
            id: sd,
          }))}
          instruction={builder.instruction}
          theme={theme}
          errors={errors}
          getValues={getValues}
        />
      </>
    );
  }

  if (builder.type !== "select") {
    showButton(true);
    const imgName = covertToCamel(builder?.title);
    return (
      <>
        {builder.type === "file" &&
          (builder.title === "Selfie" || builder.title === "Work Id") && (
            <ImageUploader
              register={register}
              change={handleImageChange}
              image={image}
              type={"file"}
              label={builder.instruction}
              name={imgName}
              required={requiredField.includes(imgName)}
              errors={errors}
            />
          )}

        {builder.title === "Government Id" && (
          <GovernmentIdUpload
            register={register}
            theme={theme}
            tabName={tabName}
            handleFileChange={handleFileChange}
            label={builder.instruction}
            requiredField={requiredField}
            errors={errors}
            getValues={getValues}
          />
        )}

        {builder.type === "file" && builder.title === "File" && (
          <FileUploader
            register={register}
            name={inputName}
            change={handleImageChange}
            file={file}
            type={"file"}
            label={builder.instruction}
            required={requiredField.includes(inputName)}
            accept={"image/png, image/jpeg,application/pdf"}
            errors={errors}
          />
        )}
        {builder.type === "file" && builder.title === "Image" && (
          <ImageUploader
            register={register}
            change={handleImageChange}
            image={image}
            type={"file"}
            label={builder.instruction}
            name={inputName}
            required={requiredField.includes(inputName)}
            errors={errors}
          />
        )}
        {builder.type === "date" && (
          <>
            <Controller
              control={control}
              rules={{
                required: requiredField.includes(inputName)
                  ? `${builder.instruction} is required`
                  : false,
              }}
              name={inputName}
              render={({ field }) => (
                <DatePicker
                  placeholderText={builder.instruction}
                  onChange={(date) => field.onChange(date)}
                  selected={field.value ? new Date(field.value) : field.value}
                  showYearDropdown
                  dateFormat="MMMM/yyyy"
                  showMonthDropdown
                  dropdownMode="select"
                  className="datepicker"
                  autoComplete="off"
                  maxDate={new Date()}
                />
              )}
            />
            <ErrorMessage
              errors={errors}
              name={inputName}
              as="span"
              className="error-form"
            />
          </>
        )}

        {(builder.type === "text" || builder.type === "email") && (
          <Input
            register={register}
            name={inputName}
            type={builder.type}
            change={(e: any) => handleInputChange(e, tabName)}
            placeholder={builder.instruction}
            theme={theme}
            required={requiredField.includes(inputName)}
            errors={errors}
            title={builder.title}
          />
        )}
        {(builder.type === "number" || builder.type === "tel") && (
          <NumberInput
            control={control}
            register={register}
            placeholder={builder.instruction}
            change={(e: any) => handleInputChange(e, tabName)}
            required={requiredField.includes(inputName)}
            theme={theme}
            name={inputName}
            errors={errors}
            type={builder.type}
            title={builder.title}
          />
        )}
        {builder.type === "dropdown" && (
          <Select
            required={requiredField.includes(inputName)}
            register={register}
            name={inputName}
            options={builder.options}
            instruction={builder.instruction}
            theme={theme}
            errors={errors}
            handleLinkForm={handleLinkForm}
            builder={builder}
            tabId={tabId}
            linkedTabs={linkedTabs}
            getValues={getValues}
          />
        )}
        {(builder.type === "radio" || builder.type === "checkbox") && (
          <Radio
            required={requiredField.includes(inputName)}
            register={register}
            name={inputName}
            options={builder.options}
            instruction={builder.instruction}
            theme={theme}
            errors={errors}
            type={builder.type}
            handleLinkForm={handleLinkForm}
            builder={builder}
            tabId={tabId}
            linkedTabs={linkedTabs}
            getValues={getValues}
          />
        )}

        {builder.title === "List Inputs" && (
          <ListInputs
            register={register}
            control={control}
            theme={theme}
            name={inputName}
            required={requiredField.includes(inputName)}
            errors={errors}
            builder={builder}
          />
        )}
      </>
    );
  }
  return <></>;
};

export default InputGenerator;
